import { HomeState, Langue, Traduction } from '@/modules/Home/store/state';
import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { HomeModuleState } from '.';
import { ParametrageWidget } from '@/models/ParametrageWidget';

export const getters: GetterTree<HomeModuleState | HomeState, RootState> = {
    getEstimate(state) {
        return (state as HomeModuleState).widgetDevis.estimateItems;
    },
    getBilling(state) {
        return (state as HomeModuleState).widgetFactures.billingItems;
    },
    getPreventiveChart(state) {
        return (state as HomeModuleState).widgetPreventif.preventiveChartItems;
    },
    getPreventiveCircle(state) {
        return (state as HomeModuleState).widgetPreventif.preventiveCircleItems;
    },
    getPreventiveOut(state) {
        return (state as HomeModuleState).widgetTravaux.preventiveOutItems;
    },
    getInterventionRequest(state) {
        return (state as HomeModuleState).widgetDemandeIntervention.interventionRequestItems;
    },
    getShowModaleCommunication(state) {
        return (state as HomeModuleState).communication !== null;
    },
    getActualites(state) {
        return (state as HomeModuleState).actualites;
    },
    getNbNouvellesActualites(state) {
        return (state as HomeModuleState).nbNouvellesActus;
    },
    getActualiteOpen(state) {
        return (state as HomeModuleState).actualiteOpen;
    },
    getActualiteLoading(state) {
        return (state as HomeModuleState).actualiteLoading;
    },
    isRegisterMailLoading(state) {
        return (state as HomeModuleState).registerMailLoading;
    },
    getNbNouvellesReclamations(state) {
        return (state as HomeModuleState).nbNouvellesReclamation;
    },
    getLanguesDisponibles(state) : Langue[] {
        return (state as HomeModuleState).languesDisponibles;
    },
    getLangueSelectionnee(state) : Langue | undefined {
        return (state as HomeModuleState).langueSelectionnee;
    },
    getTraductions(state) : Traduction[] {
        return (state as HomeModuleState).traductions;
    },
    getModalChoixPortailOuverte(state) : boolean {
        return (state as HomeModuleState).modalChoixPortailOuverte;
    },
    getSelectedDashboard(state) {
        return (state as HomeModuleState).selectedDashboard;
    },
    getCreatedDashboard(state) {
        return (state as HomeModuleState).createdDashboard;
    },
    getEnregistrementsDashboardEnCours(state) {
        return (state as HomeModuleState).enregistementDashboardEnCours;
    },
    getWidgets(state): ParametrageWidget[] {
        return (state as HomeModuleState).widgets;
    },
    getDashboards(state) {
        return (state as HomeModuleState).dashboards;
    },
    isModaleWidgetForceOuverte(state) {
        return (state as HomeModuleState).openModaleWidget;
    },
    isDashboardLoading(state) {
        return (state as HomeModuleState).dasboardLoading;
    },
    getSatisfactionConditions(state) {
        return (state as HomeModuleState).satisfactionConditions;
    },
};
